import React, { useState, useMemo, useCallback } from 'react'
import { Box, SimpleGrid, useToast, Alert, AlertIcon, Tabs, TabList, Tab } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { ArtImage } from '../../../components/ArtImage'
import { ActionButton } from '../../../components/ActionButton'

const mockImageGroups = [
  {
    id: 1,
    name: 'Grupo Amarelo',
    codes: ['2008', '3107', '2365', '4008', '4008'],
    activeCodes: ['2008', '3107', '2365', '4008', '4008'],
    backgroundColor: '#FFEB3B',
    images: [
      { id: 1, url: 'https://via.placeholder.com/300x300/FFEB3B/000000?text=Arte+1' },
      { id: 2, url: 'https://via.placeholder.com/300x300/FFEB3B/000000?text=Arte+2' },
      { id: 3, url: 'https://via.placeholder.com/300x300/FFEB3B/000000?text=Arte+3' },
      { id: 4, url: 'https://via.placeholder.com/300x300/FFEB3B/000000?text=Arte+4' },
    ],
  },
  {
    id: 2,
    name: 'Grupo Azul',
    codes: ['2008', '3107', '2365', '4008', '4008'],
    activeCodes: ['2008', '3107', '2365', '4008', '4008'],
    backgroundColor: '#4F6272',
    images: [
      { id: 5, url: 'https://via.placeholder.com/300x300/4F6272/FFFFFF?text=Arte+1' },
      { id: 6, url: 'https://via.placeholder.com/300x300/4F6272/FFFFFF?text=Arte+2' },
      { id: 7, url: 'https://via.placeholder.com/300x300/4F6272/FFFFFF?text=Arte+3' },
      { id: 8, url: 'https://via.placeholder.com/300x300/4F6272/FFFFFF?text=Arte+4' },
    ],
  },
  {
    id: 3,
    name: 'Grupo Laranja',
    codes: ['2008', '3107', '2365', '4008', '4008'],
    activeCodes: ['2008', '3107', '2365', '4008', '4008'],
    backgroundColor: '#FFB74D',
    images: [
      { id: 9, url: 'https://via.placeholder.com/300x300/FFB74D/000000?text=Arte+1' },
      { id: 10, url: 'https://via.placeholder.com/300x300/FFB74D/000000?text=Arte+2' },
      { id: 11, url: 'https://via.placeholder.com/300x300/FFB74D/000000?text=Arte+3' },
      { id: 12, url: 'https://via.placeholder.com/300x300/FFB74D/000000?text=Arte+4' },
    ],
  },
]

export function FinalSelectionStep() {
  const toast = useToast()
  const navigate = useNavigate()
  const [selectedImagesMap, setSelectedImagesMap] = useState({})

  const handleSelectImage = useCallback((groupId, imageId) => {
    setSelectedImagesMap((prev) => ({
      ...prev,
      [groupId]: imageId,
    }))
  }, [])

  const allGroupsSelected = useMemo(() => {
    return mockImageGroups.every((group) => selectedImagesMap[group.id] !== undefined)
  }, [selectedImagesMap])

  const handleValidateAndFinalize = useCallback(() => {
    if (!allGroupsSelected) {
      toast({
        title: 'Seleção incompleta',
        description: 'É necessário selecionar uma arte de cada grupo antes de finalizar.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      })
      return
    }

    toast({
      title: 'Artes selecionadas com sucesso!',
      status: 'success',
      duration: 3000,
      isClosable: true,
    })

    console.log('Navegando de volta para a página inicial após finalização')
    navigate('/pattern')
  }, [allGroupsSelected, toast, navigate])

  return (
    <Box pb="80px">
      {' '}
      <Alert status="info" mb={6} borderRadius="md">
        <AlertIcon />
        Escolha apenas 1 arte entre as 4 opções em cada grupo
      </Alert>
      <SimpleGrid columns={{ base: 2, md: 2 }} spacing={4} mb={4}>
        {mockImageGroups.map((group) => (
          <Box key={group.id} mb={8}>
            <Tabs variant="unstyled" mb={2}>
              <TabList bg="white" borderRadius="md" p={1} display="inline-flex" overflowX="auto" maxWidth="100%" gap={1}>
                {group.codes.map((code, index) => (
                  <Tab
                    key={index}
                    borderRadius="md"
                    py={1}
                    px={3}
                    fontSize="sm"
                    bg={group.activeCodes.includes(code) ? (code === '2365' ? '#378BBF' : 'gray.100') : 'white'}
                    color={group.activeCodes.includes(code) && code === '2365' ? 'white' : 'black'}
                    _hover={{ bg: 'gray.200' }}
                  >
                    Cod - {code}
                  </Tab>
                ))}
              </TabList>
            </Tabs>

            <SimpleGrid columns={{ base: 2, md: 2 }} spacing={3}>
              {group.images.map((image) => (
                <ArtImage
                  key={image.id}
                  image={{ ...image, backgroundColor: group.backgroundColor }}
                  selectedStatus={selectedImagesMap[group.id]}
                  onSelect={handleSelectImage}
                  groupId={group.id}
                  displayType="selection"
                  imageHeight="200px"
                />
              ))}
            </SimpleGrid>
          </Box>
        ))}
      </SimpleGrid>
      <ActionButton onClick={handleValidateAndFinalize} isDisabled={!allGroupsSelected} position="fixed">
        Validar e Finalizar
      </ActionButton>
    </Box>
  )
}
